import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import Customer from '../../../models/Customer';
import commonStyles from '../common.module.css';
import Error from '../../common/Error/Error';
import warningLogo from '../../../assets/images/warning.png';
import Input from '../../common/Input/Input';
import Select from '../../common/Select/Select';
import { isValidEmail, isValidPhone } from '../../../utils/validation';
import CountrySelect from '../../common/CountrySelect/CountrySelect';
import styles from './BasicInformation.module.css';

type LegalBasicInformationProps = {
  customer: Customer
  onUpdate: (newCustomer: Customer) => void
  error: string
}

function LegalBasicInformationRegister(props: LegalBasicInformationProps) {
  const { t } = useTranslation();
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowError(props.error !== '');
  }, [props.error]);

  return (
    <div className={commonStyles.container}>
      <div className={commonStyles.header}>
        {showError && (
          <Error
            messageText={props.error}
            logoSrc={warningLogo}
            logoAltText={t('customer.validation.warningLogo')}
          />
        )}
      </div>
      <div className={commonStyles.row}>
        <div className={styles.field}>
          <Input
            id='name'
            placeholder={t('customer.basicInfo.placeholder.companyName')}
            type='text'
            maxLength={70}
            label={t('customer.basicInfo.label.companyName')}
            required
            onUpdate={(value) => props.onUpdate({
              ...props.customer,
              name: value,
            })}
            error={showError && props.customer.name === ''}
          />
        </div>
        <div className={styles.field}>
          <Input
            id='registrationCode'
            placeholder={t('customer.basicInfo.placeholder.registrationCode')}
            type='text'
            maxLength={35}
            label={t('customer.basicInfo.label.registryCode')}
            required
            onUpdate={(value => props.onUpdate({
              ...props.customer,
              registrationCode: value.toLowerCase(),
            }))}
            error={showError && props.customer.registrationCode === ''}
          />
        </div>
        <div className={styles.field}>
          <CountrySelect
            required
            label={t('customer.basicInfo.label.country')}
            isLongLabel
            onUpdate={(value) => props.onUpdate({
              ...props.customer,
              country: value,
            })}
            error={showError && props.customer.country === ''}
          />
        </div>
      </div>
      <div className={commonStyles.row}>
        <div className={styles.field}>
          <Input
            id='phone'
            placeholder={t('customer.basicInfo.placeholder.phone')}
            type='text'
            maxLength={15}
            label={t('customer.basicInfo.label.phone')}
            onUpdate={(value) => props.onUpdate({
              ...props.customer,
              phone: value,
            })}
            error={showError && !isValidPhone(props.customer.phone, true)}
          />
        </div>
        <div className={styles.field}>
          <Input
            id='email'
            placeholder={t('customer.basicInfo.placeholder.email')}
            type='email'
            label={t('customer.basicInfo.label.email')}
            required
            onUpdate={(value) => props.onUpdate({
              ...props.customer,
              email: value,
            })}
            error={showError && !isValidEmail(props.customer.email, false)}
          />
        </div>
        <div className={styles.field}>
          <Select
            id='language'
            options={[{ value: 'EN' }, { value: 'EE' }, { value: 'LV' }, { value: 'LT' }]}
            label={t('customer.basicInfo.label.language')}
            required
            onUpdate={(value) => props.onUpdate({
              ...props.customer,
              preferredLanguage: value,
            })}
            error={showError && props.customer.preferredLanguage === ''}
          />
        </div>
      </div>
    </div>
  );
}

export default LegalBasicInformationRegister;
